import React, { Component } from 'react';
// import Center from 'react-center';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import {
  SPI_MONITOR_REDUCERNAME,
  spiMonitorReducer } from './SpiMonitorReducer';
import PropTypes from 'prop-types';

class Header extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isToggleOn: true
    };
    this.handleClick = this.handleClick.bind(this);
  }

  OpenDocumentation () {
    window.open('./documentation.html', '_blank');
  }

  handleClick () {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn
    }));
  }

  render () {
    return (
      <div>
        <Row className='no-gutters'>
          <Col xs='2' />
          <Col xs='8'>
            <div className='header-logo'>
              <a className='header-logo' href='https://www.knmi.nl/home'>
                <img
                  className='header-img'
                  src='https://cdn.knmi.nl/assets/logo_large-a9be0e49aed0aa1f72a7da54d348d14ce94d070e7950f67dbc85039f0574ca48.png'
                />
              </a>
            </div>
          </Col>
          <Col xs='2'>
            <div style={{ textAlign: 'right', marginTop: '40px' }}>
              <a
                className='header-meta'
                href='https://www.knmi.nl/over-het-knmi/about'
              >
                English
              </a>
              {'\xa0\xa0|\xa0\xa0'}
              <a href='#' className='header-meta' onClick={this.handleClick}>
                {this.state.isToggleOn ? 'hoog contrast' : 'normaal contrast'}
              </a>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    spiMonitor: state[SPI_MONITOR_REDUCERNAME]
      ? state[SPI_MONITOR_REDUCERNAME]
      : spiMonitorReducer()
  };
};

Header.propTypes = {
  dispatch: PropTypes.func,
  spiMonitor: PropTypes.object
};

export default connect(mapStateToProps)(Header);
